import { createCryptoService } from "~/utils/crypto";
import { normalizeClusters } from "~/utils/branch-offices";

const cryptoService = createCryptoService(process.env.baseEncryptionKey, process.env.baseEncryptionIv);

export async function fetchBranchOffices(axios, cluster, search = "") {
    const endpoint = `web/page/branch-offices/${encodeURIComponent(cluster)}`;
    // This read-only search endpoint reads a plain search field, not a dt envelope.
    const response = search ? await axios.post(`${endpoint}/search`, { search }, { timeout: 60000 }) : await axios.get(endpoint, { timeout: 60000 });
    const encrypted = response?.data?.data?.attributes?.encrypted;
    if (!encrypted) throw new Error("Missing branch office payload");
    const content = cryptoService.decrypt(encrypted);
    if (!content || !Array.isArray(content.branches) || !normalizeClusters(content.clusters).some((entry) => entry.id === cluster)) {
        throw new Error("Invalid branch office payload");
    }
    return content;
}
